import { createAsyncThunk,createSlice } from "@reduxjs/toolkit";
import Admin from "apis/Admin";


export const verifyPodcastRequest = createAsyncThunk("verifyPodcast",async([start,limit])=>{
  const response = await Admin.get(`podcast/verification/${start}/${limit}`);
  console.log(response,"verify podcasts response")
  return response.data.data
});

export const acceptPodcastVerify = createAsyncThunk(
  "podcast accept",
  async (data) => {
    await Admin.post("podcast/verify",data);
    console.log("verify data")
    return data;
  }
)
export const rejectPodcastRequest = createAsyncThunk(
  "reject podcast",
  async (data) => {
    await Admin.post("podcast/reject",data);
    console.log("reject data")
    return data;
  }
)

const verifyPodcastSlice = createSlice({
  name:"verifyPodcast",
  initialState:{verifyPodcastList:[],totalList:'',message:"",loading:false},
  reducers:{},
  extraReducers:{
    [verifyPodcastRequest.fulfilled]:(state,action) => {
      return { ...state, verifyPodcastList:action.payload.podcasts, totalList: action.payload.totalPodcasts,message:action.payload.message,loading:false}
    },
    [verifyPodcastRequest.pending]:(state) => {
       return {...state,loading:true}
    },
    [verifyPodcastRequest.rejected]:(state,action) => {
      return {
        ...state,
        verifyPodcastList:action.payload,
        message:"no data",
        loading:false
      }
    },
    [acceptPodcastVerify.fulfilled]: (state, _action) => {
      return {
        ...state,
        loading: false
      };
    },
    [acceptPodcastVerify.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [acceptPodcastVerify.rejected]: (state) => {
      return {
        ...state,
        loading: false,
        message: "News Deletion Failed"
      };
    },
    [rejectPodcastRequest.fulfilled]: (state, _action) => {
      return {
        ...state,
        loading: false
      };
    },
    [rejectPodcastRequest.pending]: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    [rejectPodcastRequest.rejected]: (state) => {
      return {
        ...state,
        loading: false,
        message: "News Deletion Failed"
      };
    },
  }
})

export default verifyPodcastSlice.reducer;